import React from "react";
import cn from "classnames";
import c from "../../../styles/container.module.scss";
import s from "../TabsGrid.module.scss";
import RichText from "../../Common/RichText";
import type { RichTextContent } from "../../../lib/storyblok/types/fieldtypes/richText";

type Props = {
  description: RichTextContent;
  index: number;
};

const TabHeader = ({ description, index }: Props) => (
  <div className={cn(s.header, c.narrow)} tabIndex={index}>
    <RichText content={description} alignment={"alignCenter"} />
  </div>
);

export default TabHeader;
